import { render, staticRenderFns } from "./ColorStore.vue?vue&type=template&id=e76daf38"
import script from "./ColorStore.vue?vue&type=script&lang=js"
export * from "./ColorStore.vue?vue&type=script&lang=js"
import style0 from "./ColorStore.vue?vue&type=style&index=0&id=e76daf38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports